import Copyright from './Copyright';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import {grey} from '@mui/material/colors';


export default function Footer(){
    return (
  
        <div>
            <Divider />
            <Box
                sx={{
                  backgroundColor: grey[50],
                  p:5,
                 
              }}
            >
                <Typography  variant="h6">
                    <Copyright />
                </Typography>        
            </Box>
        </div>
    );
}
